import styled, { css } from 'styled-components';

export const BaseMain = styled.div<{ hideHeader?: boolean }>`
  ${({ theme, hideHeader }) => css`
    max-width: ${theme.grid.container};
    margin-left: auto;
    margin-right: auto;
    padding: ${hideHeader ? '1rem' : '1.6rem'} 3.2rem;
  `}
`;
